import React, { useState } from "react";
import classNames from "classnames";
import styles from "./EventsSnapshotsTab.module.css";

import Card from "../../../shared/Card";
import SearchBar from "DreamStream/Shared/SearchBar";
import EventSnapshotList from "../EventSnapshotList";
import CreateSnapshotModal from "../CreateSnapshotModal";
import ViewSnapshotModal from "../ViewSnapshotModal";
import NotesModal from "../NotesModal";

// Temporary - DELETE when API
import { Default as MembersExample } from "../ViewSnapshotModal/ViewSnapshotModal.stories";

const MockSnapshot = {
  fileName: "file name",
  createdOn: "02/24/2020 11:01:01",
  eventName: "Event Name",
  totalUsers: "000",
  notes: null,
};

let mockData = [
  {
    ...MockSnapshot,
    fileName: "fr-2020-puryear-sun2",
    eventName: "Spring Leadership 2022 - Virtual",
    totalUsers: "1400",
    notes: "Notes are shown here if applicable.",
  },
  {
    ...MockSnapshot,
    fileName: "fr-2020-puryear-sun1",
    notes: "Notes are shown here if applicable.",
  },
  MockSnapshot,
  MockSnapshot,
  MockSnapshot,
];

// API request should be made when the openModal variable changes from null.
const mockMembers = MembersExample.args.members;

/**
 * View component.
 * Handles the Events/Snapshots Tab for the Events page.
 */
export function EventsSnapshotsTab() {
  const [sortedSnapshots, setSortedSnapshots] = useState(mockData);

  // Determines which modal is open.
  // Takes an property with details to fill the modal.
  const [openModal, setOpenModal] = useState(null);

  // Handles search
  const handleQuery = (query) => {
    // Case insensitive
    const regExp = new RegExp(query, "i");

    const newSort =
      query.length > 0
        ? mockData.filter(
            (snapshot) =>
              regExp.test(snapshot.fileName) || regExp.test(snapshot.eventName)
          )
        : mockData;
    setSortedSnapshots(newSort);
  };

  // Reformat snapshot for modal
  const setModalSnapshot = (modal, snapshot) => {
    const createdOn = snapshot.createdOn.split(" ");
    setOpenModal({
      modal: modal,
      snapshot: {
        ...snapshot,
        date: createdOn[0],
        time: createdOn[1],
      },
    });
  };

  return (
    <>
      <Card
        className={styles.card}
        children={
          <section>
            <div className={styles.header}>
              <h4>SNAPSHOTS</h4>
            </div>
            <div className={styles["options-bar"]}>
              <SearchBar
                placeholderText={"Search by snapshot name"}
                btn={true}
                onInput={(value) => handleQuery(value)}
                searchDelay={0}
                minChar={0}
                className={styles["search-bar"]}
              />
              <div className={styles["snapshot-bar"]}>
                <p aria-label="get-snapshot" className={styles.bold}>
                  Get Snapshot:
                </p>
                <button
                  aria-labelledby="get-snapshot"
                  type="button"
                  className={styles.bold}
                  onClick={() => setOpenModal({ modal: "new" })}
                >
                  Capture
                </button>
              </div>
            </div>
            <div className={styles["list-container"]}>
              <EventSnapshotList
                snapshots={sortedSnapshots}
                onClick={(snapshot) => setModalSnapshot("snapshots", snapshot)}
                onNoteClick={(snapshot) => setModalSnapshot("notes", snapshot)}
              />
            </div>
            {openModal && (
              <>
                {openModal.snapshot && (
                  <>
                    <NotesModal
                      isOpen={openModal.modal === "notes"}
                      onClose={() => setOpenModal(null)}
                      onClick={() =>
                        setOpenModal({ ...openModal, modal: "snapshots" })
                      }
                      note={openModal.snapshot}
                    />
                    <ViewSnapshotModal
                      isOpen={openModal.modal === "snapshots"}
                      onClose={() => setOpenModal(null)}
                      onClick={() => {
                        alert("Generate Report onClick fired.");
                        setOpenModal(null);
                      }}
                      snapshot={openModal.snapshot}
                      members={mockMembers}
                      onDelete={() => {
                        alert("onDelete fired.");
                        setOpenModal(null);
                      }}
                    />
                  </>
                )}
                <div className={styles["create-modal"]}>
                  <CreateSnapshotModal
                    isOpen={openModal.modal === "new"}
                    onClose={() => setOpenModal(null)}
                    onClick={(snapshot) => {
                      alert("Create onClick fired.");
                      setOpenModal(null);
                    }}
                  />
                </div>
              </>
            )}
          </section>
        }
      />
    </>
  );
}
